import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Date from "src/components/util/date";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import ImageLoader from "src/components/image-loader/ImageLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    cursor: "pointer",
    padding: theme.spacing(2),
    margin: "auto",
    marginTop: "16px",
    "&:hover": {
      backgroundColor: "#f4f4f4",
    },
    "&.active": {
      backgroundColor: "lightcoral",
    },
    "&.selected": {
      backgroundColor: "lightblue",
    },
  },
  image: {
    width: 96,
    height: 60,
  },
  img: {
    margin: "auto",
    display: "block",
    maxWidth: "100%",
    maxHeight: "100%",
  },
}));

export default function Post({
  post,
  currentPost,
  selectPost,
  selectedPost,
  setOpenAfterExpiredSetting,
}) {
  const classes = useStyles();
  const { img_hor, title, publishedAt, primary_category } = post;
  const [chosenPost, setChosenPost] = useState(currentPost);


  return (
    <div className={classes.root}>
      <Paper
        className={clsx(classes.paper, {
          active: chosenPost && chosenPost.id === post.id,
          selected: selectedPost && selectedPost.id === post.id,
        })}
        onClick={() => selectPost(post)}
      >
        <Grid container spacing={2}>
          <Grid item>
            <div className={classes.image}>
              {/* <img className={classes.img} alt={title} src={img_hor} /> */}
              <ImageLoader
                src={img_hor}
                alt={title}
                classImg={classes.img}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm container>
            <Grid item xs container direction="column" spacing={2}>
              <Grid item xs>
                <Typography gutterBottom variant="subtitle1">
                  {title}
                </Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                  {primary_category.name}
                </Typography>
                <Date
                  typecode="ready"
                  hideUpdatedTime={true}
                  published_at={publishedAt}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      {selectedPost && selectedPost.id === post.id && (
        <Button
          className="mt-2"
          onClick={() => setOpenAfterExpiredSetting(true)}
        >
          Set thời gian hạ bài
        </Button>
      )}
    </div>
  );
}
